import React, { useEffect, useRef } from 'react';
import PrivacyPolicy, { PrivacyPolicyText } from '../../../../../components/PrivacyPolicy';
import { isMobileOidc } from '../../../../../utilities/oidc/oidc';
import { useRegisterComponent } from '../../../../orchestrator';
import { WELCOME_PAGE_ID } from '../../constants';
import { useWelcomePageContext } from '../../contexts';
import { useMicrobranding } from '../../../../../utilities/hooks/useMicrobranding';

export const WelcomePrivacyPolicy = () => {
  useRegisterComponent(WelcomePrivacyPolicy.name);

  const privacyPolicyMessageRef = useRef<HTMLParagraphElement>(null);

  const { oidcContext, isEmbedded } = useMicrobranding();

  const { setPrivacyPolicyText } = useWelcomePageContext();

  const privacyPolicyText = privacyPolicyMessageRef.current?.innerHTML || '';

  useEffect(() => {
    if (privacyPolicyText) {
      setPrivacyPolicyText(privacyPolicyText);
    }
  }, [privacyPolicyText, setPrivacyPolicyText]);

  return (
    <PrivacyPolicy
      isEmbedded={isEmbedded}
      isMobileOidc={isMobileOidc(oidcContext)}
      pageId={WELCOME_PAGE_ID}
      privacyPolicyText={PrivacyPolicyText.passwordSignup}
      ref={privacyPolicyMessageRef}
    />
  );
};
